import { Column, Row, SizedBox } from "../CommonBaseComponents";
import { C3Text } from "../text/CustomText";
import CustomRadios from "./CustomRadios";
import styled from "styled-components";
import { TitleAndInput } from "../input/TitleAndInput";
import { useState } from "react";
import CustomInput from "../input/CustomInput";

const shopSearchMockValues = ["Ram 8 / LGF0001", "Ram 9 / LGF0002", "Ram 10 / LGF0003"];

export const TitleAndInputGrid = styled.div`
    display: grid;
    grid-template-columns: 0.7fr 1.3fr;
    gap: 17px;
    width: 100%;
    box-sizing: border-box;
    align-items: ${(props) => props.alignItem || "center"};
    justify-content: flex-start;
`;

export const TitleAndRadio = ({
    title,
    options,
    selectedOption,
    setSelectedOption,
    isEditMode,
    addItem,
    readOnly,
    ...props
}) => {
    const [quotaNnmber, setQuotaNumber] = useState();

    return (
        <>
            <Column width={"100%"}>
                <Row justifyContent={"space-between"} width={"100%"}>
                    <TitleAndInputGrid>
                        <Row alignItem={"center"}>
                            <C3Text>{title}</C3Text>
                        </Row>
                        {isEditMode ? (
                            <CustomRadios
                                options={options}
                                selectedOption={selectedOption}
                                setSelectedOption={setSelectedOption}
                                readOnly={readOnly}
                            />
                        ) : (
                            <CustomInput
                                dropdownValues={options}
                                inputValue={selectedOption}
                                type={"select"}
                                disabled={true}
                                {...props}
                            />
                        )}
                    </TitleAndInputGrid>
                </Row>
                {addItem === "input" && (
                    <>
                        <SizedBox height={"12px"} />
                        <TitleAndInput
                            type={"normal"}
                            placeholder={"Please enter quota."}
                            inputValue={quotaNnmber}
                            setInputValue={setQuotaNumber}
                            disabled={!isEditMode}
                        />
                    </>
                )}
                {addItem === "search" && (
                    <>
                        <SizedBox height={"12px"} />
                        <TitleAndInput
                            type={"search"}
                            placeholder={"Search"}
                            dropdownValues={props.values}
                            inputValue={""}
                            setInputValue={props.setSerachSelectedOption}
                            disabled={!isEditMode}
                        />
                        <SizedBox height={"6px"} />
                    </>
                )}
            </Column>
        </>
    );
};
